import { DocumentTemplateType, SecurityPermissionLevel } from '../../../api-client/autogenerated';

/**
 * The rules for who is offered the CENTERLINE AI reviewer on a document (docs/superpowers/plans/
 * 2026-10-16-centerline-ai-document-review.md §4.1), without the hooks that gather their inputs.
 * Every condition must hold, and none widens a backend permission: the token route still enforces
 * CENTERLINE AI access, and the Query Tool's project scoping is unchanged.
 */

export type ReviewKind = 'submittal' | 'rfi';

/** The kind of review a document type gets, or null. Packages are left out of the first version. */
export function reviewKindFor(
  docType: DocumentTemplateType | null | undefined,
  isPackage: boolean,
): ReviewKind | null {
  if (isPackage) return null;
  if (docType === DocumentTemplateType.Submittals) return 'submittal';
  if (docType === DocumentTemplateType.RequestsForInformation) return 'rfi';
  return null;
}

export interface ReviewVisibilityInput {
  flagOn: boolean;
  docType: DocumentTemplateType | null | undefined;
  isPackage: boolean;
  /** `getDocPermission()` for this document. */
  permission: number | null | undefined;
  /** The backend's verdict for the document's project (`useCenterlineAiAvailable`). */
  available: boolean;
}

/** REVIEW permission (3) on the document, the check the card already uses for Architect-only rows. */
export const hasReviewPermission = (permission: number | null | undefined): boolean =>
  !!permission && permission >= SecurityPermissionLevel.NUMBER_3;

export function showsReviewRow(input: ReviewVisibilityInput): boolean {
  return (
    input.flagOn &&
    reviewKindFor(input.docType, input.isPackage) !== null &&
    hasReviewPermission(input.permission) &&
    input.available
  );
}
